import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import moment from "moment";
import DataGrid, { Column, HeaderFilter, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../helpers/validaciones";
import { Button } from "devextreme-react";

class TablaConvenios extends React.PureComponent {

  handleView = (e) => {
    //this.props.dispatch(doGetEmpresaById(e.data));
  }


  render() {
    return (
      <React.Fragment>
        <div className="contenedor-master-detail">
          <DataGrid
            dataSource={this.props.data.Agreements}
            noDataText=""
            className="custom-table"
            showBorders={false}
            showColumnLines={false}
            allowColumnResizing={false}
            columnAutoWidth={false}
            showRowLines={false}
            rowAlternationEnabled
            onContentReady={(e) => {
              if (e.component.totalCount() === 0) {
                const config = {};
                config.addClass = "table-margin";
                const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                const element = validaciones.noDataDOMElement(config, "Sin Información");
                //noDataSpan.appendChild(element);
              }
            }}
          >
            
              <Column
                alignment="center"
                dataField="Name"
                caption="Nombre documento"
              />

              <Column
                alignment="center"
                dataField="CreationDate"
                caption="Fecha de subida"
                cellTemplate={(element, row) => {
                  ReactDOM.render(
                    <div>
                      {moment(row.data.CreationDate).format("DD/MM/YYYY")}
                    </div>
                    , element
                  );
                }}
              />

              <Column
                caption=""
                alignment="right"
                cellTemplate={(element, row) => {
                  ReactDOM.render(
                    <Button className="slimButton" type="success" text="Ver" onClick={() => this.handleView(row)} />
                    , element
                  );
                }}
              />

            <Paging pageSize={4} enabled />
            <Pager showNavigationButtons showInfo infoText={(page, total) => `Página ${page} de ${total}`} />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
  empresa: state.mantenedorEmpresas.empresa
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaConvenios);
